module.exports = __webpack_public_path__ + "static/img/preview-02.2f491d9b.webp";